export default class Stocktake {
  mapData(data) {
    this.id = data.id;
    this.stocktake_number = data.stocktake_number;
    this.status = data.status;
    this.notes = data.notes;
    this.created_by_account_id = data.created_by_account_id;
    this.created_by = data.created_by;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.started_at = data.started_at;
    this.submitted_at = data.submitted_at;
    this.approved_at = data.approved_at;
    this.approved_by = data.approved_by;
    this.rejection_reason = data.rejection_reason;
    this.items = data.items || [];
    this.available_transitions = data.available_transitions || [];
    this.summary = data.summary || {
      total_items: 0,
      counted_items: 0,
      skipped_items: 0,
      pending_items: 0,
      total_expected_quantity: 0,
      total_physical_quantity: 0,
      total_variance: 0
    };
  }

  // Status display helpers
  getStatusDisplay() {
    const statusMap = {
      'Draft': { text: 'Nháp', color: 'default' },
      'InProgress': { text: 'Đang kiểm', color: 'primary' },
      'Submitted': { text: 'Đã gửi', color: 'warning' },
      'Approved': { text: 'Đã duyệt', color: 'success' },
      'Rejected': { text: 'Từ chối', color: 'error' }
    };
    return statusMap[this.status] || { text: this.status, color: 'default' };
  }

  // Progress calculation
  getProgressPercentage() {
    if (this.summary.total_items === 0) return 100; // Empty stocktake is considered 100% complete
    return Math.round((this.summary.counted_items / this.summary.total_items) * 100);
  }

  // Available actions based on status and permissions
  getAvailableActions(userRole = 'STAFF') {
    const actions = [];
    
    if (this.status === 'Draft') {
      actions.push({ action: 'start', label: 'Bắt đầu kiểm', variant: 'contained', color: 'primary' });
      actions.push({ action: 'edit', label: 'Sửa', variant: 'outlined', color: 'inherit' });
    } else if (this.status === 'InProgress') {
      // If there are items to count, show continue button
      if (this.summary.total_items > 0) {
        actions.push({ action: 'continue', label: 'Tiếp tục kiểm', variant: 'contained', color: 'primary' });
      }
      // Always show submit if progress is 100% (including empty stocktakes)
      if (this.getProgressPercentage() === 100) {
        actions.push({ action: 'submit', label: 'Gửi duyệt', variant: 'contained', color: 'success' });
      }
    } else if (this.status === 'Submitted' && (userRole === 'ADMIN' || userRole === 'Admin')) {
      actions.push({ action: 'approve', label: 'Duyệt', variant: 'contained', color: 'success' });
      actions.push({ action: 'reject', label: 'Từ chối', variant: 'contained', color: 'error' });
    } else if (this.status === 'Approved' || this.status === 'Rejected') {
      actions.push({ action: 'view', label: 'Xem chi tiết', variant: 'outlined', color: 'inherit' });
    }
    
    return actions;
  }

  // Format date for display
  getFormattedDate(field = 'created_at') {
    if (!this[field]) return '-';
    return new Date(this[field]).toLocaleDateString('vi-VN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  // Get variance summary
  getVarianceSummary() {
    const variance = this.summary.total_variance;
    if (variance === 0) return { text: 'Chính xác', color: 'green' };
    if (variance > 0) return { text: `+${variance.toFixed(2)}`, color: 'orange' };
    return { text: variance.toFixed(2), color: 'red' };
  }
}